import React from 'react'
import { connect } from 'react-redux'
import { getPayment, getTranslation } from '../../actions/dataActions'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import * as resource from '../../constants/Resources'

const PaymentModal = props => {
    const {
        paymentDevice,          
    } = props;

    const payment = props.getPayment(paymentDevice.paymentid);
    const header = `${props.getTranslation(resource.PAY)}${(payment !== null ? ` ${payment.Description}` : '')}`;
    let shouldShowModal = paymentDevice.busy || (paymentDevice.paymentid > 0 && paymentDevice.status);

    return (
        <Modal className='paymentModal'
            contentLabel=""
            isOpen={shouldShowModal}
            style={properties.paymentModalStyle}
        >
            <div className="paymentModal_header">
                <div className="header_top">
                    {header}
                </div>
            </div>

            <div className="paymentModal_content">
                {paymentDevice.busy && paymentDevice.status}
            </div>
            <div className="paymentModal_footer">
                {/* No cancel button for customer display */}
            </div>
        </Modal>
    )
}

function mapStateToProps(state) {
    return {
        paymentDevice: state.receiptState.receipt.paymentdevice,
    }
}

export default connect(mapStateToProps, {
    getPayment,
    getTranslation
})(PaymentModal)


// WEBPACK FOOTER //
// src/components/CustomerDisplay/PaymentModal.jsx